module.exports = __webpack_public_path__ + "img/addGroupCode_bg.59f1f89f.png";